import Vue from 'vue';

/**
 * Convert camelCase or PascalCase (with acronym handling) to a human readable string
 * Examples:
 *   ScheduledPendingReview -> "Scheduled Pending Review"
 *   HTMLParser -> "HTML Parser"
 *   completedPending -> "completed Pending"
 */
export function humanizeCase(value: string | null | undefined): string {
  if (!value || typeof value !== 'string') {
    return value as any;
  }
  // Insert space between sequences like "HTMLParser" -> "HTML Parser"
  const withAcronymsHandled = value.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
  // Insert space between camelCase boundaries like "completedPending" -> "completed Pending"
  return withAcronymsHandled.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

Vue.filter('humanizeCase', (value: string) => humanizeCase(value));
